import { gsap, ScrollTrigger } from "@/composeables/gsap";

export const init = () => {

    const sections = gsap.utils.toArray(".section-trust-anchors");

    sections.forEach(function (section) {

        const items = section.querySelectorAll(".section-trust-anchors__item");
        if (!items.length) return;

        // Start links + transparent -> beim Reveal gestaggert nach rechts einfaden.
        gsap.set(items, { autoAlpha: 0, x: -24 });

        ScrollTrigger.batch(items, {
            interval: 0.1,
            invalidateOnRefresh: true,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: batch => gsap.to(batch, { autoAlpha: 1, x: 0, stagger: 0.12, overwrite: true, ease: "expo", duration: 0.9 }),
        });

    });
}

export default init;
